(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState || Array.from({
            length: 4
        }, function() {
            return Array(4).fill(0);
        });
        this.board = JSON.parse(JSON.stringify(this.initialState));
        this.status = "idle";
        this.score = 0;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.move("down");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.move("up");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.move("right");
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.move("left");
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = JSON.parse(JSON.stringify(this.initialState));
                this.status = "idle";
                this.score = 0;
            }
        },
        {
            key: "move",
            value: function move(direction) {
                var _this = this, _loop = function(col) {
                    var column = direction === "up" ? _this.board.map(function(row) {
                        return row[col];
                    }) : _this.board.map(function(row) {
                        return row[col];
                    }).reverse();
                    column = direction === "up" ? _this.combineTiles(column) : _this.combineTiles(column).reverse();
                    for(var row = 0; row < 4; row++)_this.board[row][col] = column[row];
                };
                var oldBoard = JSON.stringify(this.board);
                if (this.status !== "playing") return;
                if (direction === "up" || direction === "down") for(var col = 0; col < 4; col++)_loop(col);
                else if (direction === "left" || direction === "right") {
                    for(var row = 0; row < 4; row++)if (direction === "left") this.board[row] = this.combineTiles(this.board[row]);
                    else this.board[row] = this.combineTiles(this.board[row].reverse()).reverse();
                }
                if (oldBoard !== JSON.stringify(this.board)) this.addRandomTile();
                this.endGame();
            }
        },
        {
            key: "combineTiles",
            value: function combineTiles(row) {
                var newRow = row.filter(function(val) {
                    return val !== 0;
                });
                for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                    newRow[i] *= 2;
                    this.score += newRow[i];
                    newRow[i + 1] = 0;
                }
                newRow = newRow.filter(function(val) {
                    return val !== 0;
                });
                return newRow.concat(Array(4 - newRow.length).fill(0));
            }
        },
        {
            key: "getEmptyCells",
            value: function getEmptyCells() {
                var emptyCells = [];
                for(var row = 0; row < 4; row++){
                    for(var col = 0; col < 4; col++)if (this.board[row][col] === 0) emptyCells.push({
                        row: row,
                        col: col
                    });
                }
                return emptyCells;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = this.getEmptyCells();
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], row = _emptyCells_Math_floor.row, col = _emptyCells_Math_floor.col;
                this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "endGame",
            value: function endGame() {
                var gameOver = true;
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    if (this.board[row][col] >= 2048) this.status = "win";
                    if (row < 3 && this.board[row][col] === this.board[row + 1][col] || col < 3 && this.board[row][col] === this.board[row][col + 1]) gameOver = false;
                }
                if (this.getEmptyCells().length === 0 && gameOver) this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
document.addEventListener("DOMContentLoaded", function() {
    var updateButton = function updateButton() {
        var button = document.querySelector(".button");
        if ($197cd56b15c33885$var$game.status === "idle") {
            button.classList.remove("restart");
            button.classList.add("start");
            button.textContent = "Start";
        } else {
            button.classList.remove("start");
            button.classList.add("restart");
            button.textContent = "Restart";
        }
    };
    var updateMessage = function updateMessage() {
        switch($197cd56b15c33885$var$game.status){
            case "idle":
                document.querySelector(".message-start").classList.remove("hidden");
                document.querySelector(".message-win").classList.add("hidden");
                document.querySelector(".message-lose").classList.add("hidden");
                break;
            case "playing":
                document.querySelector(".message-start").classList.add("hidden");
                break;
            case "win":
                document.querySelector(".message-win").classList.remove("hidden");
                break;
            case "lose":
                document.querySelector(".message-lose").classList.remove("hidden");
                break;
            default:
                break;
        }
        updateButton();
    };
    var getScore = function getScore() {
        document.querySelector(".game-score").textContent = $197cd56b15c33885$var$game.score;
    };
    var updateBoard = function updateBoard() {
        var cells = document.querySelectorAll(".field-cell");
        var index = 0;
        for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
            var cell = cells[index];
            cell.textContent = $197cd56b15c33885$var$game.board[row][col] || "";
            cell.className = "field-cell field-cell--".concat($197cd56b15c33885$var$game.board[row][col]);
            index++;
        }
    };
    document.querySelector(".button").addEventListener("click", function() {
        if ($197cd56b15c33885$var$game.status === "idle") $197cd56b15c33885$var$game.start();
        else $197cd56b15c33885$var$game.restart();
        updateMessage();
        getScore();
        updateBoard();
    });
    document.addEventListener("keydown", function(e) {
        switch(e.key){
            case "ArrowLeft":
                $197cd56b15c33885$var$game.moveLeft();
                break;
            case "ArrowRight":
                $197cd56b15c33885$var$game.moveRight();
                break;
            case "ArrowUp":
                $197cd56b15c33885$var$game.moveUp();
                break;
            case "ArrowDown":
                $197cd56b15c33885$var$game.moveDown();
                break;
        }
        updateMessage();
        getScore();
        updateBoard();
    });
});

})();
//# sourceMappingURL=index.ae8ac2bc.js.map
